import DiscountTag from 'components/common/DiscountTag';
import StrikethroughSkeleton from 'components/common/StrikethroughSkeleton';
import Text from 'components/common/Text';

const TempoOrderSummaryPPS = ({ box, classes }) => {
  return (
    <div
      className={`${classes} flex justify-between border-b border-solid border-charcoal-60 py-4`}
    >
      <Text brandStylesOverrides="font-medium text text-secondary" className="flex-1">
        Price Per Meal
      </Text>

      <Text brandStylesOverrides={'textMd flex font-medium text-tempo-black-100'}>
        {box?.promoApplied ? (
          <>
            <DiscountTag box={box} />
            <StrikethroughSkeleton
              strikethroughText={box?.pricePerServingFormatted}
              textDisplayed={box?.promo?.pricePerServingFormatted}
              className={'text-tempo-black-100'}
            />
          </>
        ) : (
          box?.pricePerServingFormatted
        )}
      </Text>
    </div>
  );
};

TempoOrderSummaryPPS.propTypes = {
  classes: PropTypes.string,
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    pricePerServingFormatted: PropTypes.string.isRequired,
    promo: PropTypes.shape({
      pricePerServingFormatted: PropTypes.string,
    }),
  }),
};

export default TempoOrderSummaryPPS;
